// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"71":"dd34a6b183f3068e","97":"5098601f79a8f70b","397":"550e37e3620b24bd","740":"31a373311d497448","832":"6debbb872fc047b8","922":"4c4b13f39fd4984e","989":"b24c8607ce0e05b7"}[chunkId] + ".js";
};